import { stringify as qsStringify } from 'query-string';
import type {
	WorkspaceId,
	CmdbObjectId,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import type {
	ObjectConnectedTicketsPaginatedRequest,
	FilterQueryParams,
} from '../types/object-connected-tickets.tsx';
import { getCmdbRestBaseUrl } from './index.tsx';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectconnectedtickets/${objectId}
 */
const getCmdbObjectConnectedTicketsBaseUrl = (workspaceId: WorkspaceId, objectId: CmdbObjectId) =>
	`${getCmdbRestBaseUrl(workspaceId)}/objectconnectedtickets/${objectId}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectconnectedtickets/${objectId}/tickets
 */
export const getCmdbObjectConnectedTicketsUrl = (
	workspaceId: WorkspaceId,
	objectId: CmdbObjectId,
	filterQueryParams: FilterQueryParams = {},
): string => {
	const url = `${getCmdbObjectConnectedTicketsBaseUrl(workspaceId, objectId)}/tickets`;
	const encodedQueryParams = qsStringify(filterQueryParams);
	if (encodedQueryParams) {
		return `${url}?${encodedQueryParams}`;
	}
	return url;
};

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectconnectedtickets/${objectId}/paginatedtickets
 */
export const getCmdbObjectConnectedTicketsPaginatedUrl = (
	workspaceId: WorkspaceId,
	objectId: CmdbObjectId,
	queryParams: ObjectConnectedTicketsPaginatedRequest,
) =>
	`${getCmdbObjectConnectedTicketsBaseUrl(workspaceId, objectId)}/paginatedtickets?${qsStringify(
		queryParams,
	)}`;
